import { BadgeIndianRupee, Gift, Send, Truck } from "lucide-react";

const shopperSteps = [
  {
    icon: Gift,
    step: "01",
    title: "Start a split from the product or cart page",
    body: "The organizer chooses Split with Friends, picks the number of contributors, and enters delivery details once.",
  },
  {
    icon: BadgeIndianRupee,
    step: "02",
    title: "Organizer pays their share first",
    body: "The split begins only after the organizer completes their own payment, so every group purchase starts with real intent.",
  },
  {
    icon: Send,
    step: "03",
    title: "Invite friends with secure payment links",
    body: "Each participant receives a private contribution link and pays directly through the merchant's normal checkout experience.",
  },
  {
    icon: Truck,
    step: "04",
    title: "The merchant fulfills once the split is fully paid",
    body: "Splitkart tracks progress in real time and places the final shippable order only after 100% of the amount is collected.",
  },
];

interface CustomerJourneySectionProps {
  compact?: boolean;
  pageHeading?: boolean;
}

export function CustomerJourneySection({ compact = false, pageHeading = false }: CustomerJourneySectionProps) {
  const Heading = pageHeading ? "h1" : "h2";

  return (
    <section className={compact ? "" : "section"}>
      <div className="container-tight">
        <div className="mx-auto max-w-2xl text-center">
          <span className="eyebrow">Customer journey</span>
          <Heading className="mt-4 text-3xl font-bold md:text-5xl">What the shopper sees from start to finish.</Heading>
          <p className="mt-4 text-lg text-muted-foreground">
            The flow is simple on purpose: one person organizes, everyone contributes, and the order moves forward only when it is fully paid.
          </p>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-2">
          {shopperSteps.map((step) => {
            const Icon = step.icon;

            return (
              <div key={step.step} className="rounded-3xl border border-border bg-card p-8 shadow-soft">
                <div className="flex items-center gap-4">
                  <div className="rounded-2xl bg-primary/10 p-3 text-primary">
                    <Icon className="h-5 w-5" />
                  </div>
                  <div className="text-xs font-semibold tracking-[0.24em] text-primary">STEP {step.step}</div>
                </div>
                <h2 className="mt-5 text-2xl font-bold">{step.title}</h2>
                <p className="mt-3 text-muted-foreground">{step.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
